import { Button, ButtonProps } from "@mui/material";
import React from "react";

/**
 * A styled button component used for actions in the client controls
 */
export const ActionButton: React.FC<ButtonProps> = (props) => (
  <Button
    variant="contained"
    color="primary"
    size="small"
    {...props}
  />
); 